var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"title":'Evolutions'}}),_c('b-container',{staticClass:"mt-2",attrs:{"fluid":"xxl"}},[_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('LegamDataTables',_vm._b({},'LegamDataTables',_vm.$data,false))],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }